<template>
  <div>
    <van-nav-bar title="收藏的商品" left-arrow @click-left="onClickLeft" />

    <van-panel v-if="hotList.length>0">
      <van-card
        v-for="(goods, index) in hotList"
        :key="index"
        :price="goods.je"
        :desc="goods.spContent"
        :title="goods.spName"
        :thumb="goods.introductionPicture"
        :thumb-link="goods.img"
        @click="viewGoodsDetail(goods.id)">
      </van-card>
    </van-panel>

    
        
    <div class="no-data" v-if="hotList.length==0">
      <p style="text-align: center; color: lightgray">
        <van-icon name="goods-collect-o" style="text-align: center" size="3rem" /><br />
         啊欧，您还没有收藏任何商品
      </p>
      <van-button type="default" block round @click="getmodel('search')">去逛逛</van-button>
    </div>
   
      
    
  </div>
</template>

<script>
import {
  Checkbox,
  SubmitBar,
  CheckboxGroup,
  NavBar,
  Divider,
  List,
  Toast,
  Cell,
  CellGroup,
  Card,
  Col,
  Icon,
  Row,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Search,
  Panel,
} from "vant";

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Divider.name]: Divider,
    [List.name]: List,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Search.name]: Search,
    [Panel.name]: Panel,
  },
  data() {
    return {
     
      hotList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 商品详情
    viewGoodsDetail(id) {
      // this.$router.push({path: '/goods?id='+id})

      this.$router.push({ name: "goods", query: { id: id } });
    },
    onClickLeft() {
      this.$router.push({ path: "/user" });
    },
    init() {
      let _this = this;
      let url = "/memberBusiness/collect/selectCol";
       return new Promise((resolve, reject) => {
      _this.$axios
        .get(url)
        .then((data) => {
          this.hotList = data.data;
        })
        .catch((erro) => {
          reject(erro);
        });
           });
    },
  },
};
</script>

<style lang="less">

.favorite {
  &-checkall {
    padding: 0px 10px;
    margin-right: 45%;
  }
  &-card {
    margin-left: 25px;
  }
  &-item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }
}
</style>
